import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Auth session behavior:
// By default supabase-js persists the session in localStorage, so if the user closes and reopens
// the app, it will restore the session without asking to log in again.
//
// Requirement (Ops): always require login again when the user comes back, unless they are
// actively logged in in the current runtime.
//
// Setting persistSession:false keeps the session only in memory (lost on refresh/close).
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
})
